import { render, staticRenderFns } from "./goodandfails.vue?vue&type=template&id=08b8ac61&"
import script from "./goodandfails.vue?vue&type=script&lang=js&"
export * from "./goodandfails.vue?vue&type=script&lang=js&"
import style0 from "./goodandfails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports